// A FAILURE INSIDE AN HTTP 200 — said once, for every screen that reads a party list with its balances.
//
// GET /api/parties?with_balances=true reads the ledger's account lists to fill each row's `balances`. When a list could not be
// read it still answers 200, with every row of it carrying `balances: {}` — the very payload of a party who owes nothing — and
// `balances_read: false` (bff/src/routes/parties.ts). Read as it came, that is a desk with nothing in it: "Nothing to convert.",
// "customer square", a box with nothing to suggest a balance from. It is a FAILED read (design system Appendix B), whatever the
// status line says; the flag is absent when balances were not asked for, and then there is nothing to read.

/** The books' sentence for Details when an HTTP 200 said it could not read a list of balances (there is no error object). */
export const BALANCES_UNREAD = 'The ledger answered, but a list of balances could not be read — a box with nothing in it here is unknown, not square.';

/** True when a party-list answer says a ledger list was not read. `=== false`, not "not true": an answer that carries no flag
 *  asked for no balances, or read them all. */
export function balancesUnread(answer: { balances_read?: boolean } | null | undefined): boolean {
  return answer?.balances_read === false;
}
